(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparacion-productos-similares-v2"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('cz-catalog-matrix')) {
  class CzCatalogMatrix extends HTMLElement {
    connectedCallback() {
      this.loadRecommendations();
    }

    async loadRecommendations() {
      if (this.dataset.performed === 'true') {
        this.markBestPrice();
        this.removeWhiteBackgrounds();
        return;
      }

      if (!this.dataset.url) return;

      try {
        const response = await fetch(this.dataset.url, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (!response.ok) {
          throw new Error('No se pudieron cargar las recomendaciones');
        }

        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');

        const incoming = parsed.querySelector(
          'cz-catalog-matrix[data-section-id="' +
          CSS.escape(this.dataset.sectionId) +
          '"]'
        );

        if (!incoming || !this.isConnected) return;

        this.innerHTML = incoming.innerHTML;
        this.dataset.performed = incoming.dataset.performed || 'true';
        this.dataset.hasProducts = incoming.dataset.hasProducts || 'false';

        if (this.dataset.hasProducts !== 'true') {
          this.hidden = true;
          return;
        }

        this.hidden = false;
        this.markBestPrice();
        this.removeWhiteBackgrounds();

      } catch (error) {
        console.warn('[Carzamo] No se pudieron cargar productos relacionados.');
        this.hidden = true;
      }
    }

    markBestPrice() {
      const cells = [
        ...this.querySelectorAll('[data-cz-matrix-price]')
      ];

      const availableCells = cells.filter((cell) => {
        return cell.dataset.available === 'true';
      });

      const prices = availableCells
        .map((cell) => Number(cell.dataset.price || 0))
        .filter((price) => price > 0);

      if (prices.length < 2) return;

      const lowestPrice = Math.min(...prices);

      availableCells.forEach((cell) => {
        if (Number(cell.dataset.price) === lowestPrice) {
          cell.classList.add('is-best-price');
        }
      });
    }

    removeWhiteBackgrounds() {
      const images = [
        ...this.querySelectorAll('.cz-remove-white-bg')
      ];

      images.forEach((image) => {
        if (image.dataset.backgroundRemoved === 'true') return;

        const source = new Image();
        source.crossOrigin = 'anonymous';
        source.src = image.currentSrc || image.src;

        source.onload = () => {
          try {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d', {
              willReadFrequently: true
            });

            const scale = Math.min(
              1,
              900 / source.naturalWidth
            );

            canvas.width = Math.round(source.naturalWidth * scale);
            canvas.height = Math.round(source.naturalHeight * scale);

            context.drawImage(
              source,
              0,
              0,
              canvas.width,
              canvas.height
            );

            const imageData = context.getImageData(
              0,
              0,
              canvas.width,
              canvas.height
            );

            const pixels = imageData.data;
            const width = canvas.width;
            const height = canvas.height;
            const visited = new Uint8Array(width * height);
            const queue = [];

            const isWhiteBackground = (index) => {
              const red = pixels[index];
              const green = pixels[index + 1];
              const blue = pixels[index + 2];

              return (
                red > 238 &&
                green > 238 &&
                blue > 238 &&
                Math.max(red, green, blue) -
                Math.min(red, green, blue) < 16
              );
            };

            const addPixel = (x, y) => {
              if (
                x < 0 ||
                y < 0 ||
                x >= width ||
                y >= height
              ) {
                return;
              }

              const position = y * width + x;

              if (visited[position]) return;

              const index = position * 4;

              if (!isWhiteBackground(index)) return;

              visited[position] = 1;
              queue.push(position);
            };

            for (let x = 0; x < width; x++) {
              addPixel(x, 0);
              addPixel(x, height - 1);
            }

            for (let y = 0; y < height; y++) {
              addPixel(0, y);
              addPixel(width - 1, y);
            }

            let pointer = 0;

            while (pointer < queue.length) {
              const position = queue[pointer++];
              const x = position % width;
              const y = Math.floor(position / width);

              addPixel(x + 1, y);
              addPixel(x - 1, y);
              addPixel(x, y + 1);
              addPixel(x, y - 1);
            }

            for (
              let position = 0;
              position < visited.length;
              position++
            ) {
              if (!visited[position]) continue;

              pixels[position * 4 + 3] = 0;
            }

            context.putImageData(imageData, 0, 0);

            image.src = canvas.toDataURL('image/png');
            image.removeAttribute('srcset');
            image.dataset.backgroundRemoved = 'true';

          } catch (error) {
            console.warn(
              '[Carzamo] No se pudo eliminar el fondo de una imagen.',
              error
            );
          }
        };
      });
    }
  }

  customElements.define(
    'cz-catalog-matrix',
    CzCatalogMatrix
  );
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.headerInner = document.querySelector('.header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      if (this.headerIsAlwaysSticky) this.reveal;
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      if (this.header) {
        observer.observe(this.header);
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
        this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-always-sticky');
      }

      if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
        this.header.classList.remove('shopify-section-header-sticky');
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (this.disclosures) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }
      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      if (this.disclosureLists) {
        this.disclosureLists.forEach((disclosureList) => {
          disclosureList.setAttribute('hidden', true);
        });
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();

      // Mirror the zoom gallery to the current main gallery (subset + order)
      // and open on exactly the clicked image, keyed by media id.
      const sectionId = this.id.replace('ProductModal-', '');
      const mediaId = opener?.getAttribute('data-media-id');
      if (typeof window.syncProductZoomGallery === 'function') {
        window.syncProductZoomGallery(sectionId, mediaId);
      }
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
